<template>
    <a-layout-header class="header">

        <div class="header-title" v-if="headerTitle">
            <a-menu v-model:selectedKeys="selectedK" mode="horizontal" :items="items" @click="handleClick" />
        </div>

        <div class="left-list">
            <div class="popo-am">
                <div class="popo-div">
                    <a-popover placement="bottomRight" v-model:open="visibleCommentOutlined" title="消息通知"
                        trigger="click">
                        <template #content>
                            <div class="msg-remind">
                                <span v-if="announceList">无</span>
                                <a-card hoverable v-for="(item, index) in announceList" :key="index" size="small"
                                    @click="readMsg(item.id, item.readTime)" :title="item.title" class="msg-card"
                                    :headStyle="{ backgroundColor: '#0984e3', color: '#ffffff' }">
                                    <template #extra>
                                        <a-tag v-if="item.readTime != undefined" color="green">已读</a-tag>
                                        <a-tag v-if="item.readTime == undefined" color="red">未读</a-tag>
                                    </template>
                                    <p>
                                        <span> 优 先 级 : </span>
                                        <a-tag v-if="item.priority === '普通'" color="red">普通</a-tag>
                                        <a-tag v-if="item.priority === '加急'" color="orange">加急</a-tag>
                                        <a-tag v-if="item.priority === '紧急'" color="blue">紧急</a-tag>
                                    </p>
                                    <p v-if="item.createdAt != undefined">
                                        <span>发布时间：</span>
                                        <a href="#">{{ item.createdAt }}</a>
                                    </p>
                                    <p v-if="item.readTime != undefined">
                                        <span>查看时间：</span>
                                        <a href="#">{{ item.readTime }}</a>
                                    </p>
                                </a-card>
                                <readAnnounce ref="msgChildOpen" />
                            </div>
                        </template>
                    </a-popover>
                </div>
                <a-badge :count="announceList.length" :number-style="{
                    backgroundColor: '#27ae60',
                    color: 'white',
                    boxShadow: '0 0 0 1px #d9d9d9 inset'
                }">
                    <CommentOutlined @click="hideCommentOutlined" style="font-size: 28px; color: #636e72;" />
                </a-badge>
            </div>
        </div>

        <div class="user-info">
            <span class="user-name" @click="showUsers">特邀用户</span>
            <a-avatar :size="40" src="https://www.antdv.com/assets/logo.1ef800a8.svg" @click="showUsers" />
        </div>
        <a-drawer title="个人设置" width="380" :closable="false" :visible="visibleUsers" @close="onCloseUsers">

            <div v-if="userData">
                <a-spin :spinning="spinning" size="large">
                    <a-badge-ribbon text="正常" color="green">
                        <a-card hoverable title="用户信息" :headStyle="{ backgroundColor: '#0984e3', color: '#ffffff' }">
                            <div style="display: flex">
                                <div class="user-data">
                                    <p v-show="visibleEditUs == false"><strong>昵称：</strong>{{ userData.nickname }}</p>
                                    <p v-show="visibleEditUs"><strong>昵称：</strong> <a-input
                                            v-model:value="userData.nickname" style="width: 50%;" /></p>
                                    <p v-show="visibleEditUs == false"><strong>账户：</strong>{{ userData.username }}</p>
                                    <p v-show="visibleEditUs"><strong>账户：</strong> <a-input
                                            v-model:value="userData.username" style="width: 50%;" /></p>
                                    <p v-show="visibleEditUs == false"><strong>电话：</strong>{{ userData.phoneNumber }}
                                    </p>
                                    <p v-show="visibleEditUs"><strong>电话：</strong> <a-input
                                            v-model:value="userData.phoneNumber" style="width: 50%;" /></p>
                                    <p><strong>部门：</strong>{{ userData.pramData.dept.deptName }}</p>
                                    <p><strong>权限：</strong>{{ userData.pramData.permissions.permissionName }}</p>
                                </div>
                                <div class="user-avatar">
                                    <a-avatar :size="50" :src="userData.avatar" />
                                </div>
                            </div>
                            <template #actions>

                                <span v-if="visibleEditUs">
                                    <a-button class="user_edit" type="primary" @click="pushEditUs">提交</a-button>
                                    <a-button class="user_edit" type="primary" @click="closeEditUs">取消</a-button>
                                </span>
                                <a-button v-if="visibleEditUs == false" type="primary"
                                    @click="showEditUs">编辑信息</a-button>
                                <a-button type="primary" @click="showEditPas">修改密码</a-button>
                            </template>
                        </a-card>
                    </a-badge-ribbon>
                </a-spin>

                <div class="user-pas" v-if="visibleEditPas">
                    <a-card title="修改账户密码" :headStyle="{ backgroundColor: '#0984e3', color: '#ffffff' }">
                        <template #extra><a href="#" style="color: white;" @click="showEditPas">取消</a></template>
                        <p class="p_pas"><strong>原密码：</strong><a-input-password v-model:value="oldPas"
                                placeholder="请输入原密码" />
                        </p>
                        <p class="p_pas"><strong>新密码：</strong><a-input-password v-model:value="newPas"
                                placeholder="请输入新密码" />
                        </p>
                        <template #actions>
                            <a-button type="primary" @click="pushPas">确认修改</a-button>
                        </template>
                    </a-card>
                </div>

                <a-button danger @click="out" class="outButton">退出账户</a-button>
            </div>
        </a-drawer>
    </a-layout-header>
</template>
<script>
import { CommentOutlined } from '@ant-design/icons-vue';
import readAnnounce from '@/views/announce/modal/readAnnounce.vue';
import { MenuOutlined, TeamOutlined, LockOutlined, UserOutlined, ApartmentOutlined, NumberOutlined, ProfileOutlined } from '@ant-design/icons-vue';
import { getInfoBytoken, updatePasByoldPas, updateUsByToken, listUniRead, setRead } from '@/api/service';
import { useMenuStore } from '@/store/index';
import { message } from 'ant-design-vue';
import { useRouter } from 'vue-router'
import { logOut } from '@/api/auth';
import { ref, h, watch, nextTick } from 'vue';

export default {
    name: 'AppHeader',
    components: {
        CommentOutlined,
        readAnnounce
    },
    setup() {
        const visibleCommentOutlined = ref(false);
        const visibleUsers = ref(false);
        const visibleEditPas = ref(false);
        const visibleEditUs = ref(false);
        const userData = ref(null);
        const spinning = ref(true);
        const selectedK = ref([]);
        const announceList = ref([]);
        const oldPas = ref('');
        const newPas = ref('');
        const items = ref([]);
        const router = useRouter();
        const current = ref(['mail']);
        const menuStore = useMenuStore();
        const headerTitle = ref(true);
        const hideCommentOutlined = () => { announce(); visibleCommentOutlined.value = true; };
        const onCloseUsers = () => { visibleUsers.value = false; };
        const msgChildOpen = ref(null);


        //退出
        const out = async () => {
            const response = await logOut();
            if (response.code == 200) {
                router.push('login');
                window.localStorage.clear();
            }
        };
        //显示用户信息
        const showUsers = async () => {
            visibleUsers.value = true;
            const response = await getInfoBytoken();
            if (response.code == 200) {
                userData.value = response.data;
            }
            spinning.value = false;
        };
        //修改密码
        const showEditPas = () => {
            if (visibleEditPas.value) {
                visibleEditPas.value = false;
            } else {
                visibleEditPas.value = true;
            }
        }
        //修改用户信息
        const showEditUs = () => {
            if (visibleEditUs.value) {
                visibleEditUs.value = false;
            } else {
                visibleEditUs.value = true;
            }
        }
        //关闭编辑
        const closeEditUs = () => {
            visibleEditUs.value = false;
        }
        //提交用户信息修改
        const pushEditUs = async () => {
            if (userData.value.username == '' || userData.value.nickname == '') {
                message.error('名称不可为空');
                return;
            }
            const response = await updateUsByToken({ 'newUser': userData.value });
            if (response.code == 200) {
                message.success(response.msg);
            }
            visibleEditUs.value = false;
        };
        //提交密码修改
        const pushPas = async () => {
            if (oldPas.value == '' || newPas.value == '') {
                message.error('请填写密码');
                return;
            }
            const response = await updatePasByoldPas({ 'oldPas': oldPas.value, 'newPas': newPas.value });
            if (response.code == 200) {
                message.success(response.msg);
            }
            visibleEditPas.value = false;
        };
        //获取通知信息
        const announce = async () => {
            const response = await listUniRead();
            if (response.code == 200) {
                announceList.value = response.data;
            }
        }
        //菜单渲染
        const iconStyle = {
            // fontSize: '20px',
            color: '#27ae60',
        };
        // 监听 store记载子菜单
        watch(() => menuStore.children, (m) => {
            if (Array.isArray(m)) {
                selectedK.value = [menuStore.selectable];
                headerTitle.value = false;
                items.value = m.map(item => ({
                    key: item.menuCode,
                    label: item.name,
                    title: item.name,
                    class: 'scale-up-hor-center',
                    icon: () => {
                        switch (item.icon) {
                            case 'MenuOutlined':
                                return h(MenuOutlined, { style: iconStyle });
                            case 'TeamOutlined':
                                return h(TeamOutlined, { style: iconStyle });
                            case 'LockOutlined':
                                return h(LockOutlined, { style: iconStyle });
                            case 'ApartmentOutlined':
                                return h(ApartmentOutlined, { style: iconStyle });
                            case 'UserOutlined':
                                return h(UserOutlined, { style: iconStyle });
                            case 'NumberOutlined':
                                return h(NumberOutlined, { style: iconStyle });
                            case 'ProfileOutlined':
                                return h(ProfileOutlined, { style: iconStyle });
                            default:
                                return null;
                        }
                    }
                }));

                // 动态刷新后触发动画
                nextTick(() => {
                    headerTitle.value = true;
                });
            } else {
                console.error('Expected array but got:', m);
            }
        }, { immediate: true });
        //跳转菜单
        const handleClick = (menuInfo) => {
            const selectedItem = menuStore.children.find(item => item.menuCode === menuInfo.key);
            if (selectedItem && selectedItem.url) {
                router.push(selectedItem.url);
                menuStore.selectTb(selectedItem.menuCode);
            }
        };
        //读取通知公告
        const readMsg = async (id, readTime) => {
            msgChildOpen.value.id = id;
            msgChildOpen.value.open = true;
            if (readTime === null) {
                await setRead(id);
            }
        }

        return {
            hideCommentOutlined,
            showUsers,
            onCloseUsers,
            out,
            showEditPas,
            pushPas,
            showEditUs,
            pushEditUs,
            closeEditUs,
            visibleEditUs,
            announceList,
            announce,
            router,
            userData,
            oldPas,
            spinning,
            newPas,
            selectedK,
            readMsg,
            msgChildOpen,
            items,
            menuStore,
            headerTitle,
            current,
            visibleUsers,
            handleClick,
            visibleEditPas,
            visibleCommentOutlined
        };
    }
}

</script>
<style scoped>
@keyframes scale-up-hor-center {
    0% {
        transform: scaleX(0.4);
    }

    100% {
        transform: scaleX(1);
    }
}

.header {
    background: #fff;
    padding: 10px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
}

.header-title {
    text-align: center;
    width: 1600px;
    font-size: 18px;
    font-weight: bold;
    animation: scale-up-hor-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}

.user-info {
    width: 170px;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    align-items: center;
    padding: 10px;
}

.user-info:hover {
    cursor: pointer;
}

.user-pas {
    width: 100%;
    margin-top: 30px;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
    flex-direction: column;
}

.user-data {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
    flex-direction: column;
}

.user-name {
    font-size: 18px;
    font-weight: bold;
}

.left-list {
    display: flex;
    justify-content: space-between;
}

.popo-div {
    margin-top: 15px;
    margin-left: 40px;
    position: relative;
    left: 27px;
    top: 5px;
}

.popo-am {
    display: flex;
    transition: transform 0.2s ease-in-out;
    /* 增加过渡时间 */
}

.popo-am:hover {
    transform: translateY(-5px) scale(1.05);
    ;
    /* 鼠标经过时放大效果 */
}

.user-info p {
    margin-bottom: 10px;
}

.status-active {
    color: green;
}

.outButton {
    position: absolute;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
}

.p_pas {
    width: 285px;
}

.user_edit {
    width: 40%;
    margin-left: 5px;
}

.task-remind {
    max-height: 600px;
    /* 设置容器最大高度 */
    overflow-y: auto;
    /* 启用垂直滚动条 */
    display: flex;
    flex-direction: column;

}

.msg-remind {
    max-height: 600px;
    padding: 10px;
    /* 设置容器最大高度 */
    overflow-y: auto;
    /* 启用垂直滚动条 */
    display: flex;
    flex-direction: column;
}

.task-card {
    width: 200px;
    margin-top: 5px;
}

.msg-card {
    width: 250px;
    margin-top: 15px;
    margin-bottom: 10px;
}

.ellipsis-text {
    max-width: 150px;
    /* 限制宽度，根据需求调整 */
    white-space: nowrap;
    /* 禁止文本换行 */
    overflow: hidden;
    /* 超出部分隐藏 */
    text-overflow: ellipsis;
    /* 超出部分显示省略号 */
}
</style>